<template>
	<el-dialog :visible.sync="showyubao" title="预报" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div class="yubao">
			<el-card class="box-card" label="" shadow="hover" style="margin-top:-20px">
				<div slot="header" class="clearfix">
					<span>收货地址</span>   <el-button type="warning" size="mini" style="margin-left:30px" @click="copyaddress">一键复制</el-button>
				</div>
				<el-form ref="form" :model="address" label-width="80px" size="mini">
				  <el-form-item label="收件人">
						<span>{{address.name}}</span>
				  </el-form-item>
				  <el-form-item label="联系电话">
					  <span>{{address.phone}}</span>
				  </el-form-item>
				  <el-form-item label="收货地址">
					  <span v-if="ischina">{{address.province}} {{address.city}} {{address.district}} {{address.detailaddr}}</span>
					  <span else >{{address.postcode}}, {{address.detailaddr}}{{address.street}}{{address.district}}, {{address.city}}, {{address.province}}</span>
				  </el-form-item>
				 </el-form>
			 </el-card>
			<el-card class="box-card" label="" shadow="hover">
				<div slot="header" class="clearfix">
					<span>发货信息</span>
				</div>
				<el-form ref="form" label-width="80px" size="mini">
				  <el-form-item label="快递单号">
				  		<el-input v-model="expressid" 
						type="textarea" :rows="5" @input="changeinput"></el-input>
						<div>
							<!--  -->
							<span>共输入 {{ allcount }} 个单号</span>
							<a v-if="filename!=''" @click="downfile" style="margin-left:10px;cursor:pointer;color:#409EFF">下载预报结果</a>
						</div>
				  </el-form-item>
				 </el-form>
			</el-card>
			<span slot="footer" class="dialog-footer" style="padding-top:0px">
				 <div style="text-align: center;">
					 <el-button type="success" size="mini" @click="Saveyubao" :disabled="btnenabled">确 定</el-button>
					 <el-button @click="cancel" size="mini">取 消</el-button>
				 </div>
			 </span>
		</div>
		
	</el-dialog>	
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
	},
	props: {
		
	},
	data() {
		return {
			address:{
				name:'',
				phone:'',
				province:'',
				city:'',
				district:'',
				street:'',
				detailaddr:'',
				postcode:''
			},
			expressid:'',
			ischina:false,
			showyubao:false,
			btnenabled:false,
			allcount:0,
			filename:'',
			divclass:'yubao'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/haitaomanager/yubao.scss');
		});
	},
	methods:{
		init(param){
			this.filename='';
			this.expressid='';
			this.btnenabled=false,
			this.allcount=0;
			this.showyubao=true;
			this.GetShop();
		},
		GetShop(){
			var that=this;
			this.$apipost.get.GetShopByUser().then(res => {
				if(res.info!=''){
					that.address=res.info;
				}
			});
		},
		changeinput(){
			if(this.expressid!=''){
				this.btnenabled=false;
				var expressid=this.formatexpressid(this.expressid);
				if(expressid.replace(/★/g,'')==''){
					this.btnenabled=true;
				}else{
					if(expressid.split('★')[expressid.length-1]=='')
						this.allcount=expressid.split('★').length-1;
					else
						this.allcount=expressid.split('★').length;
					//this.expressid=expressid.replace(/★/g,'\n');
				}
			}
			else{
				this.allcount=0;
				this.btnenabled=true;
			}
			    
		},
		Saveyubao(){
			debugger
			var that=this;
			this.filename='';
			var expressid=this.formatexpressid(this.expressid);
			if(expressid.replace(/★/g,'')!=''){
				this.$tool.loading('正在预报', this.divclass);
				this.$apipost.post.Saveyubao({expressid:expressid,userid:localStorage.getItem('userid')}).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1'){
						this.$tool.message('预报成功', 1);
						that.cancel();
					}else{
						this.$tool.message(res.message, 0);
						if(res.filename!=undefined)
							that.filename=res.filename;
					}
				});
			}
		},
		downfile(){
			if(this.filename!=''){
				this.$tool.downfile(this,this.filename);
			}
		},
		cancel(){
			this.showyubao=false;
			this.$parent.refreshgrid(true);
		},
		copyaddress(){
			let oInput = document.createElement('textarea');
			oInput.value = '收件人：'+this.address.name+'\n联系电话：'+this.address.phone+'\n收货地址：';
			if(!this.ischina)
				oInput.value=oInput.value+this.address.postcode+','+this.address.detailaddr+this.address.street+this.address.district+','+this.address.city+','+this.address.province;
			else
				oInput.value=oInput.value+this.address.province+this.address.city+this.address.district+this.address.detailaddr;
			document.body.appendChild(oInput)
			oInput.select(); // 选择对象
			document.execCommand("Copy") // 执行浏览器复制命令
			this.$message({
			  message: '复制成功',
			  type: 'success',
			 duration:1000
			})
			oInput.remove();
		},
		formatexpressid(value){
			var list="";
			var str=value.replace(/\t/g,'').replace(/\n/g,'★');
			str.split('★').forEach(e=>{
				if(e.trim()!='')
					list+=e.trim()+"★";
			});
			if(list!="")
				list=list.substring(0,list.length-1);
			return list;
		}
	}
}
</script>